/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateTipoPacoteFormDto } from '../models/create-tipo-pacote-form-dto';
import { TipoPacoteCriteriaDto } from '../models/tipo-pacote-criteria-dto';
import { TipoPacoteDto } from '../models/tipo-pacote-dto';
import { TipoPacotePageDto } from '../models/tipo-pacote-page-dto';
import { UpdateTipoPacoteFormDto } from '../models/update-tipo-pacote-form-dto';


/**
 * Tipos de pacote
 */
@Injectable({
  providedIn: 'root',
})
export class TiposPacoteService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTiposPacote
   */
  static readonly GetTiposPacotePath = '/tipos-pacote';

  /**
   * Pesquisar tipos de pacote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTiposPacote()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposPacote$Response(params?: {
    criteria?: TipoPacoteCriteriaDto;
  }): Observable<StrictHttpResponse<TipoPacotePageDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposPacoteService.GetTiposPacotePath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoPacotePageDto>;
      })
    );
  }

  /**
   * Pesquisar tipos de pacote.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTiposPacote$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposPacote(params?: {
    criteria?: TipoPacoteCriteriaDto;
  }): Observable<TipoPacotePageDto> {

    return this.getTiposPacote$Response(params).pipe(
      map((r: StrictHttpResponse<TipoPacotePageDto>) => r.body as TipoPacotePageDto)
    );
  }

  /**
   * Path part for operation createTipoPacote
   */
  static readonly CreateTipoPacotePath = '/tipos-pacote';

  /**
   * Criar tipo de pacote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTipoPacote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTipoPacote$Response(params?: {

    /**
     * apiRequest
     */
    body?: CreateTipoPacoteFormDto
  }): Observable<StrictHttpResponse<TipoPacoteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposPacoteService.CreateTipoPacotePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoPacoteDto>;
      })
    );
  }

  /**
   * Criar tipo de pacote.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTipoPacote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTipoPacote(params?: {

    /**
     * apiRequest
     */
    body?: CreateTipoPacoteFormDto
  }): Observable<TipoPacoteDto> {

    return this.createTipoPacote$Response(params).pipe(
      map((r: StrictHttpResponse<TipoPacoteDto>) => r.body as TipoPacoteDto)
    );
  }

  /**
   * Path part for operation getTipoPacote
   */
  static readonly GetTipoPacotePath = '/tipos-pacote/{id}';

  /**
   * Obter tipo de pacote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTipoPacote()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoPacote$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoPacoteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposPacoteService.GetTipoPacotePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoPacoteDto>;
      })
    );
  }

  /**
   * Obter tipo de pacote.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTipoPacote$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoPacote(params: {
    id: number;
  }): Observable<TipoPacoteDto> {

    return this.getTipoPacote$Response(params).pipe(
      map((r: StrictHttpResponse<TipoPacoteDto>) => r.body as TipoPacoteDto)
    );
  }

  /**
   * Path part for operation updateTipoPacote
   */
  static readonly UpdateTipoPacotePath = '/tipos-pacote/{id}';

  /**
   * Atualizar tipo de pacote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTipoPacote()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoPacote$Response(params: {
    id: number;
    body?: UpdateTipoPacoteFormDto
  }): Observable<StrictHttpResponse<TipoPacoteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposPacoteService.UpdateTipoPacotePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoPacoteDto>;
      })
    );
  }

  /**
   * Atualizar tipo de pacote.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTipoPacote$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoPacote(params: {
    id: number;
    body?: UpdateTipoPacoteFormDto
  }): Observable<TipoPacoteDto> {

    return this.updateTipoPacote$Response(params).pipe(
      map((r: StrictHttpResponse<TipoPacoteDto>) => r.body as TipoPacoteDto)
    );
  }

  /**
   * Path part for operation ativarTipoPacote
   */
  static readonly AtivarTipoPacotePath = '/tipos-pacote/{id}/ativar';

  /**
   * Ativar Tipo Pacote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarTipoPacote()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTipoPacote$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoPacoteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposPacoteService.AtivarTipoPacotePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoPacoteDto>;
      })
    );
  }

  /**
   * Ativar Tipo Pacote.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarTipoPacote$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTipoPacote(params: {
    id: number;
  }): Observable<TipoPacoteDto> {

    return this.ativarTipoPacote$Response(params).pipe(
      map((r: StrictHttpResponse<TipoPacoteDto>) => r.body as TipoPacoteDto)
    );
  }

  /**
   * Path part for operation desativarTipoPacote
   */
  static readonly DesativarTipoPacotePath = '/tipos-pacote/{id}/desativar';

  /**
   * Desativar TipoPacote.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarTipoPacote()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTipoPacote$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoPacoteDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposPacoteService.DesativarTipoPacotePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoPacoteDto>;
      })
    );
  }

  /**
   * Desativar TipoPacote.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarTipoPacote$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTipoPacote(params: {
    id: number;
  }): Observable<TipoPacoteDto> {

    return this.desativarTipoPacote$Response(params).pipe(
      map((r: StrictHttpResponse<TipoPacoteDto>) => r.body as TipoPacoteDto)
    );
  }

}
